import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { CaseTypeDeletionImpactEntity } from '../../../domain/entities/case-type-deletion-impact.entity';

/**
 * Use case for retrieving case type deletion impact.
 * Checks dependencies before allowing case type deletion.
 */
@Injectable({ providedIn: 'root' })
export class GetCaseTypeDeletionImpactUseCase {
  private readonly repository = inject(CaseTypeRepository);
  private readonly state = inject(CaseTypeState);

  /**
   * Executes the use case to get case type deletion impact.
   * @param caseTypeId - The case type ID to check
   * @returns Observable with deletion impact details
   */
  public execute(caseTypeId: string): Observable<CaseTypeDeletionImpactEntity> {
    this.state.setLoadingCaseTypeDeletionImpact(true);
    this.state.setErrorCaseTypeDeletionImpact(null);

    return this.repository.getCaseTypeDeletionImpact(caseTypeId).pipe(
      tap((impact) => {
        this.state.setCaseTypeDeletionImpact(impact);
        this.state.setLoadingCaseTypeDeletionImpact(false);
      }),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message || 'Failed to load deletion impact';
        this.state.setErrorCaseTypeDeletionImpact(errorMessage);
        this.state.setLoadingCaseTypeDeletionImpact(false);
        throw error;
      })
    );
  }
}
